import intl from 'react-intl-universal';
import { useEffect, useState } from 'react';
import { List, Image, message, Empty } from 'antd';
import { AISupporFileType } from '@/enum/upload';
import { CloseCircleTwoTone } from '@ant-design/icons';
import { getFileNameByUrl, getFileType, getFileSuffix } from '@/utils/common';
import { IMAGE_CONFIG } from '@/commonConfig/componentConfig';
import { postRequest } from '@/utils/fetch';
import { AIHost } from '@/config';

import style from '../index.less';

type ImgItem = {
    id: number;
    brief: string; // 系列名
    category: string; // 系列ID
    name: string; // 图片名
    order_no: string; //订单号
    percent: string; // 相似度
    url: string; // 图片地址
};

export type FileItem = {
    file?: File;
    name: string;
    type?: string;
    url: string;
    // requestData: FormData;
    isSupportType?: boolean; // 是否是支持检测的文件类型
    imgList: ImgItem[];
};

interface Props {
    ip_code: string;
    fileList: File[] | string[];
    onChange: (fileList: FileItem[]) => void;
}

const FileWarning: React.FC<Props> = ({
    fileList: originFiles,
    // ip_code,
    onChange,
}) => {
    const [loading, setLodaing] = useState(false);
    const [fileList, setFileList] = useState<FileItem[]>(
        originFiles.map((file) => {
            if (typeof file === 'string') {
                return {
                    name: getFileNameByUrl(file),
                    url: file,
                    imgList: [],
                    isSupportType: true,
                };
            }

            return {
                file,
                name: file.name,
                type: file.type,
                url: URL.createObjectURL(file),
                imgList: [],
                isSupportType: true,
            };
        }),
    );
    useEffect(() => {
        if (originFiles?.length) {
            initFileList(originFiles);
        }
    }, [originFiles]);

    const fetchAIByUrl = (url: string) => {
        let api = `${AIHost}/api/v1/image/search/all/url`;
        return postRequest<{ code: string; data: any[]; message: string }>(
            api,
            { url },
            {
                interceptor: true,
                noCertificate: true,
                withCredentials: false,
            },
        );
    };

    const fetchAIByFile = (formData: FormData) => {
        let api = `${AIHost}/api/v1/image/search/all`;
        // if (ip_code) {
        //     api = `${AIHost}/api/v1/image/search?category=${ip_code}`;
        // }
        return postRequest<{ code: string; data: any[]; message: string }>(
            // `${AIHost}/api/v1/image/search?category=013`,
            api,
            formData,
            {
                interceptor: true,
                noCertificate: true,
                withCredentials: false,
            },
        );
    };

    const initFileList = async (originFileList: File[] | string[]) => {
        if (originFileList?.length) {
            setLodaing(true);
            setFileList(
                await Promise.all(
                    originFileList.map(async (file) => {
                        let item: FileItem;
                        let suffix: string = '';
                        if (typeof file === 'string') {
                            item = {
                                name: getFileNameByUrl(file),
                                url: file,
                                type: getFileSuffix(file),
                                imgList: [],
                            };
                            suffix = getFileSuffix(file);
                        } else {
                            item = {
                                file,
                                name: file.name,
                                type: file.type,
                                url: URL.createObjectURL(file),
                                imgList: [],
                            };
                            suffix = file.type?.split('/')[1];
                        }
                        const isSupportType = AISupporFileType.includes(
                            suffix.toLocaleUpperCase(),
                        );

                        item.isSupportType = isSupportType;

                        if (isSupportType) {
                            if (typeof file === 'string') {
                                await fetchAIByUrl(item.url).then((res) => {
                                    if (res?.code === 'ok') {
                                        // @ts-ignore
                                        item.imgList = res?.data?.slice(0, 4);
                                    } else {
                                        message.error(res?.message);
                                    }
                                });
                            } else {
                                let formData = new FormData();
                                // if (ip_code) {
                                //     formData.append('category', ip_code);
                                // }
                                formData.append('img_bytes', file);
                                await fetchAIByFile(formData).then((res) => {
                                    if (res?.code === 'ok') {
                                        // @ts-ignore
                                        item.imgList = res?.data?.slice(0, 4);
                                    } else {
                                        message.error(res?.message);
                                    }
                                });
                            }
                        }

                        return item;
                    }),
                ),
            );
            setLodaing(false);
        } else {
            setFileList([]);
        }
    };

    const delFile = (file: FileItem) => {
        const currentIndex = fileList.findIndex(
            (item) => item.url === file.url && item.name === file.name,
        );
        fileList.splice(currentIndex, 1);
        setFileList([...fileList]);
        onChange && onChange([...fileList]);
    };

    return fileList?.length ? (
        <List
            className={`${style.warningList} warningList`}
            loading={loading}
            dataSource={fileList}
        >
            {fileList.map((file) => {
                return (
                    <List.Item
                        key={file.url}
                        className={`${style.warningItem} warningItem`}
                    >
                        <div className={`${style.originImage} originImage`}>
                            {getFileType(file.name) === 'image' && (
                                <Image
                                    src={file.url}
                                    {...IMAGE_CONFIG}
                                />
                            )}
                            {getFileType(file.name) === 'video' && (
                                <video src={file.url} />
                            )}
                            <CloseCircleTwoTone
                                onClick={() => {
                                    delFile(file);
                                }}
                                className={`${style.closeBtn} closeBtn`}
                            />
                        </div>

                        {!file.isSupportType && (
                            <div className={style.warningTip}>
                                {intl.get('此格式不支持！')}
                            </div>
                        )}
                        {file.isSupportType && (
                            <ul
                                className={`${style.orderImageList} orderImageList`}
                            >
                                {file.imgList?.length ? (
                                    file.imgList.map((item) => (
                                        <li key={item.id}>
                                            <div>
                                                {intl.get('相似度：')}
                                                {item.percent}
                                            </div>
                                            <Image
                                                src={item.url}
                                                {...IMAGE_CONFIG}
                                            />

                                            <div>{intl.get('订单：')}</div>
                                            <div>{item.order_no}</div>
                                        </li>
                                    ))
                                ) : (
                                    <div className={style.warningTip}>
                                        {intl.get('无查询结果！')}
                                    </div>
                                )}
                            </ul>
                        )}
                    </List.Item>
                );
            })}
        </List>
    ) : (
        <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={intl.get('暂无可上传附件')}
        />
    );
};

export default FileWarning;
